import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface TypingIndicatorProps {
  name: string;
  image?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ name, image }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      className="flex items-center space-x-3 text-dark-800 mt-4 px-4"
    >
      <div className="flex items-center space-x-3">
        {image && (
          <motion.img
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            src={image}
            alt={`${name}'s avatar`}
            className="w-8 h-8 rounded-full object-cover border border-dark-400"
          />
        )}
        
        <div className="flex items-center space-x-2">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-dark-800 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-2 h-2 bg-dark-800 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-2 h-2 bg-dark-800 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
          <span className={cn(
            "text-sm font-medium",
            image ? "ml-0" : "ml-1"
          )}>
            {name} is typing...
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default TypingIndicator;